import SalaryDashboard from './pages/EmployeesPage/SalaryDashboard';
import SalaryCategories from './pages/EmployeesPage/SalaryCategories';
import PayrollOrigins from './pages/EmployeesPage/PayrollOrigins';
import PlanMensualPage from './pages/RRHHNative/PlanMensualPage';
import SalarialPage from './pages/EmployeesPage/SalarialPage';
import PersonnelDashboard from './pages/EmployeesPage/PersonnelDashboard';
import Liquidations from './pages/EmployeesPage/Liquidations';
import PayrollIndividuals from './pages/EmployeesPage/PayrollIndividuals';
import { RRHH_MANAGEMENT_RESOURCES } from './utils/employeeAccess';
import EmployeeSection from './pages/EmployeesPage/EmployeeSection';
import Evaluations from './pages/EmployeesPage/Evaluations';
import Sanctions from './pages/EmployeesPage/Sanctions';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import LoginPage from './pages/LoginPage';
import ActivateAccountPage from './pages/ActivateAccountPage';
import AgendaPage from './pages/AgendaPage';
import ChecklistPage from './pages/ChecklistPage';
import InventoryPage from './pages/InventoryPage';
import AccessPacksPage from './pages/InventoryPage/AccessPacksPage';
import RacksPage from './pages/InventoryPage/RacksPage';
import InventoryIncidentsPage from './pages/InventoryIncidentsPage';
import DisponibilidadPage from './pages/DisponibilidadPage';
import LogisticsPage from './pages/LogisticsPage';
import LocationsPage from './pages/LocationsPage';
import LugaresPage from './pages/LugaresPage';
import PersonnelPage from './pages/PersonnelPage';
import EmployeesPage from './pages/EmployeesPage';
import FieldLists from './pages/EmployeesPage/FieldLists';
import BiometricsPage from './pages/BiometricsPage';
import EquipmentPlanningPage from './pages/EquipmentPlanningPage';
import EventEquipmentPage from './pages/EventEquipmentPage';
import ClientsPage from './pages/ClientsPage';
import ProveedoresPage from './pages/ProveedoresPage';
import ProductsPage from './pages/ProductsPage';
import QuotesPage from './pages/QuotesPage';
import QuotePage from './pages/QuotePage';
import LeadsPage from './pages/LeadsPage';
import ConsultaPage from './pages/ConsultaPage';
import SettingsPage from './pages/SettingsPage';
import RrhhMisMarcasPage from './pages/RRHHNative/MisMarcasPage';
import RrhhPlanSemanalPage from './pages/RRHHNative/PlanSemanalPage';
import RrhhRelojPage from './pages/RRHHNative/RelojPage';
import RrhhTareasAdminPage from './pages/RRHHNative/TareasAdminPage';
import RrhhIncidentsPage from './pages/RRHHNative/IncidentsPage';
import RrhhValidationPage from './pages/RRHHNative/ValidationPage';
import RrhhInsightsPage from './pages/RRHHNative/InsightsPage';
import RrhhLiquidacionParametrosPage from './pages/RRHHNative/LiquidacionParametrosPage';
import RrhhConfiguracionPage from './pages/RRHHNative/ConfiguracionPage';
import RrhhFacialClockPage from './pages/RRHHNative/RelojFacialPage';
import RrhhTarifasOperacionesPage from './pages/RRHHNative/TarifasOperacionesPage';
import Layout from './components/Layout';
import SectionTabs from './components/SectionTabs';
import PermissionsPage from './pages/PermissionsPage';
import SystemStatusPage from './pages/SystemStatusPage';
import { canRead, canReadAny, defaultPathForUser, hasAnyRole } from './utils/roles';

const VENTAS_TABS = [
  { to: 'leads',        label: 'Leads',        permission: 'ventas.leads' },
  { to: 'cotizaciones', label: 'Cotizaciones', permission: 'ventas.cotizaciones' },
  { to: 'clientes',     label: 'Clientes',     permission: 'ventas.clientes' },
  { to: 'proveedores',  label: 'Proveedores',  permission: 'ventas.proveedores' },
  { to: 'productos',    label: 'Productos',    permission: 'ventas.productos' },
  { to: 'lugares',      label: 'Lugares',      permission: 'ventas.lugares' },
];

const CONFIG_TABS = [
  { to: '/sueldos/personal', label: 'Usuarios y roles', permission: 'configuracion.personal' },
  { to: 'biometria', label: 'Biometría', permission: 'configuracion.biometria' },
  { to: 'permisos', label: 'Permisos', permission: 'configuracion.permisos' },
  { to: 'ia',       label: 'Reglas de IA', permission: 'configuracion.ia' },
  { to: 'sistema',  label: 'Estado del sistema', permission: 'configuracion.sistema' },
];

const INVENTORY_TABS = [
  { to: 'stock', label: 'Stock', permission: 'inventario.stock' },
  { to: 'racks', label: 'Racks', permission: 'inventario.racks' },
  { to: 'packs', label: 'Packs', permission: 'inventario.packs' },
  { to: 'incidencias', label: 'Incidencias', permission: 'inventario.incidencias' },
];

const RRHH_TABS = [
  { to: 'plan-semanal', label: 'Plan semanal', permission: 'rrhh.plan-semanal' },
  { to: 'plan-mensual', label: 'Control', permission: 'rrhh.plan-mensual' },
  { to: 'tareas',       label: 'Tareas', permission: 'rrhh.tareas' },
  { to: 'dashboard',    label: 'Dashboard', permission: 'rrhh.dashboard' },
  { to: 'jornales',     label: 'Val. jornales', permission: 'rrhh.jornales' },
  { to: 'operaciones',  label: 'Val. operaciones', permission: 'rrhh.operaciones' },
  { to: 'reportes',     label: 'Reportes', permission: 'rrhh.reportes' },
  { to: 'analisis',     label: 'Análisis', permission: 'rrhh.analisis' },
  { to: 'incidencias',  label: 'Incidencias', permission: 'rrhh.incidencias' },
  { to: 'configuracion', label: 'Configuración', permission: 'rrhh.configuracion' },
  { separator: true },
  { to: 'mis-marcas',   label: 'Mis marcas', permission: 'rrhh.mis-marcas' },
];

const SUELDOS_TABS = [
  { to: 'empleados', label: 'Empleados', permission: 'configuracion.personal' },
  { to: 'liquidaciones', label: 'Liquidaciones', permission: 'configuracion.personal' },
  { to: 'licencias', label: 'Licencias', permission: 'configuracion.personal' },
  { to: 'certificaciones', label: 'Certificaciones', permission: 'configuracion.personal' },
  { to: 'prestamos', label: 'Préstamos y adelantos', permission: 'configuracion.personal' },
  { to: 'sanciones', label: 'Sanciones', permission: 'configuracion.personal' },
  { to: 'evaluaciones', label: 'Evaluaciones', permission: 'configuracion.personal' },
  { to: 'salarial', label: 'Salarial', permission: 'rrhh.configuracion' },
  { to: 'parametros-nuevos', label: 'Parámetros', permission: 'configuracion.personal' },
  { separator: true },
  { to: '/configuracion', label: 'Configuración', anyPermission: CONFIG_TABS.map(tab => tab.permission) },
  { to: 'personal', label: 'Accesos del personal', permission: 'configuracion.personal' },
  { to: '/configuracion/permisos', label: 'Permisos', permission: 'configuracion.permisos', showWhenDenied: true },
];

const RRHH_ROUTE_PERMISSIONS = [
  ...RRHH_TABS.map(tab => tab.permission).filter(Boolean),
  'rrhh.reloj',
];

const SUELDOS_ROUTE_PERMISSIONS = [...SUELDOS_TABS.map(tab => tab.permission).filter(Boolean), 'rrhh.remuneraciones', 'rrhh.liquidacion-parametros'];

function PrivateRoute({ children, roles, permission, anyPermission }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (anyPermission === RRHH_MANAGEMENT_RESOURCES && !canReadAny(user, anyPermission)) {
    return <section role="alert"><h2>Sin acceso</h2><p>Necesitás permiso de RRHH para ver este módulo.</p></section>;
  }
  if (anyPermission && !canReadAny(user, anyPermission)) return <Navigate to={defaultPathForUser(user)} replace />;
  if (permission && !canRead(user, permission)) return <Navigate to={defaultPathForUser(user)} replace />;
  if (roles && !hasAnyRole(user.role, roles)) return <Navigate to={defaultPathForUser(user)} replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (user) return <Navigate to={defaultPathForUser(user)} replace />;
  return children;
}

// Redirect de la ruta vieja /quotes/:id preservando el id.
function QuoteRedirect() {
  const { id } = useParams();
  return <Navigate to={`/ventas/cotizaciones/${id}`} replace />;
}

function FirstAllowedTabRedirect({ tabs, fallback }) {
  const { user } = useAuth();
  // El separador es decoración, no una pestaña: no tiene `permission` ni `to`.
  // Sin descartarlo ganaba el find —"no pide permiso, luego está permitido"—,
  // devolvía `to` undefined y el módulo caía siempre al fallback. A quien sólo
  // tenía las pestañas de después del separador lo mandaba a una que no podía
  // leer, y de ahí rebotaba afuera del módulo. Pasaba sólo en RRHH porque es la
  // única lista con separador; SectionTabs ya lo contemplaba, esto no.
  const tab = tabs.find(item => !item.separator && (!item.permission || canRead(user, item.permission)));
  return <Navigate to={tab?.to || fallback} replace />;
}

export default function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/activar-acceso" element={<ActivateAccountPage />} />
          {/* Formulario público de consulta → genera leads (sin login, se
              comparte por link; no usa PublicRoute para no redirigir a los
              usuarios logueados que quieran verlo). */}
          <Route path="/consulta" element={<ConsultaPage />} />
          <Route path="/reloj-facial" element={<RrhhFacialClockPage />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<PrivateRoute permission="agenda"><AgendaPage /></PrivateRoute>} />
            <Route path="checklist/:checklistId" element={<PrivateRoute permission="agenda.equipos.evento"><ChecklistPage /></PrivateRoute>} />
            <Route path="inventory" element={<PrivateRoute anyPermission={INVENTORY_TABS.map(tab => tab.permission)}><SectionTabs tabs={INVENTORY_TABS} moduleTitle="Inventario" moduleSubtitle="Stock, racks, packs e incidencias" /></PrivateRoute>}>
              <Route index element={<FirstAllowedTabRedirect tabs={INVENTORY_TABS} fallback="stock" />} />
              <Route path="stock" element={<PrivateRoute permission="inventario.stock"><InventoryPage /></PrivateRoute>} />
              <Route path="racks" element={<PrivateRoute permission="inventario.racks"><RacksPage /></PrivateRoute>} />
              <Route path="packs" element={<PrivateRoute permission="inventario.packs"><AccessPacksPage /></PrivateRoute>} />
              <Route path="incidencias" element={<PrivateRoute permission="inventario.incidencias"><InventoryIncidentsPage /></PrivateRoute>} />
            </Route>
            <Route path="inventory/disponibilidad" element={<PrivateRoute permission="inventario.stock"><DisponibilidadPage /></PrivateRoute>} />
            <Route path="locations" element={<PrivateRoute permission="lugares-activos"><LocationsPage /></PrivateRoute>} />
            <Route path="logistics" element={
              <PrivateRoute permission="logistica"><LogisticsPage /></PrivateRoute>
            } />
            <Route path="equipos" element={<PrivateRoute permission="agenda.equipos"><EquipmentPlanningPage /></PrivateRoute>} />
            <Route path="agenda/eventos/:eventId/equipos" element={<PrivateRoute permission="agenda.equipos.evento"><EventEquipmentPage /></PrivateRoute>} />

            {/* Ventas: cotizaciones + clientes + productos + lugares en pestañas */}
            <Route path="ventas" element={
              <PrivateRoute anyPermission={VENTAS_TABS.map(tab => tab.permission)}><SectionTabs tabs={VENTAS_TABS} moduleTitle="Ventas" moduleSubtitle="Leads, cotizaciones y catálogo comercial" /></PrivateRoute>
            }>
              {/* Aterrizar en Cotizaciones (no en Leads) cuando el permiso alcanza */}
              <Route index element={<FirstAllowedTabRedirect tabs={[...VENTAS_TABS].sort((a, b) => (b.to === 'cotizaciones') - (a.to === 'cotizaciones'))} fallback="cotizaciones" />} />
              <Route path="leads" element={<PrivateRoute permission="ventas.leads"><LeadsPage /></PrivateRoute>} />
              <Route path="cotizaciones" element={<PrivateRoute permission="ventas.cotizaciones"><QuotesPage /></PrivateRoute>} />
              <Route path="clientes" element={<PrivateRoute permission="ventas.clientes"><ClientsPage /></PrivateRoute>} />
              <Route path="proveedores" element={<PrivateRoute permission="ventas.proveedores"><ProveedoresPage /></PrivateRoute>} />
              <Route path="productos" element={<PrivateRoute permission="ventas.productos"><ProductsPage /></PrivateRoute>} />
              <Route path="lugares" element={<PrivateRoute permission="ventas.lugares"><LugaresPage /></PrivateRoute>} />
            </Route>
            {/* Detalle de cotización: fuera del layout de pestañas (página completa) */}
            <Route path="ventas/cotizaciones/:id" element={<PrivateRoute permission="ventas.cotizaciones"><QuotePage /></PrivateRoute>} />

            <Route path="configuracion/personal" element={<PrivateRoute permission="configuracion.personal"><Navigate to="/sueldos/personal" replace /></PrivateRoute>} />
            <Route path="configuracion/usuarios" element={<PrivateRoute permission="configuracion.personal"><Navigate to="/sueldos/personal" replace /></PrivateRoute>} />
            {/* Configuración: biometría, permisos y reglas de IA en pestañas */}
            <Route path="configuracion" element={
              <PrivateRoute anyPermission={CONFIG_TABS.map(tab => tab.permission)}><SectionTabs tabs={CONFIG_TABS} moduleTitle="Configuración" moduleSubtitle="Usuarios, permisos y reglas del sistema" /></PrivateRoute>
            }>
              <Route index element={<FirstAllowedTabRedirect tabs={[...CONFIG_TABS].sort((a, b) => Number(a.to.startsWith('/')) - Number(b.to.startsWith('/')))} fallback="/sueldos/personal" />} />
              <Route path="biometria" element={<PrivateRoute permission="configuracion.biometria"><BiometricsPage /></PrivateRoute>} />
              <Route path="permisos" element={<PrivateRoute permission="configuracion.permisos"><PermissionsPage /></PrivateRoute>} />
              <Route path="ia" element={<PrivateRoute permission="configuracion.ia"><SettingsPage /></PrivateRoute>} />
              <Route path="sistema" element={<PrivateRoute permission="configuracion.sistema"><SystemStatusPage /></PrivateRoute>} />
            </Route>

            {/* RRHH: módulo madre con secciones internas, igual que Ventas. */}
            <Route path="rrhh" element={
              <PrivateRoute anyPermission={RRHH_ROUTE_PERMISSIONS}><SectionTabs tabs={RRHH_TABS} moduleTitle="Horas" moduleSubtitle="Planificación, validaciones y gestión de personal" /></PrivateRoute>
            }>
              <Route index element={<FirstAllowedTabRedirect tabs={RRHH_TABS} fallback="plan-semanal" />} />
              <Route path="plan-semanal" element={<PrivateRoute permission="rrhh.plan-semanal"><RrhhPlanSemanalPage /></PrivateRoute>} />
              <Route path="plan-mensual" element={<PrivateRoute permission="rrhh.plan-mensual"><PlanMensualPage /></PrivateRoute>} />
              <Route path="tareas" element={<PrivateRoute permission="rrhh.tareas"><RrhhTareasAdminPage /></PrivateRoute>} />
              <Route path="incidencias" element={<PrivateRoute permission="rrhh.incidencias"><RrhhIncidentsPage /></PrivateRoute>} />
              <Route path="asignacion-bloques" element={<Navigate to="/rrhh/plan-semanal" replace />} />
              <Route path="jornales" element={<PrivateRoute permission="rrhh.jornales"><RrhhValidationPage kind="journals" /></PrivateRoute>} />
              <Route path="operaciones" element={<PrivateRoute permission="rrhh.operaciones"><RrhhValidationPage kind="operations" /></PrivateRoute>} />
              <Route path="dashboard" element={<PrivateRoute permission="rrhh.dashboard"><RrhhInsightsPage kind="dashboard" /></PrivateRoute>} />
              <Route path="reportes" element={<PrivateRoute permission="rrhh.reportes"><RrhhInsightsPage kind="reportes" /></PrivateRoute>} />
              <Route path="analisis" element={<PrivateRoute permission="rrhh.analisis"><RrhhInsightsPage kind="analisis" /></PrivateRoute>} />
              <Route path="mis-marcas" element={<PrivateRoute permission="rrhh.mis-marcas"><RrhhMisMarcasPage /></PrivateRoute>} />
              <Route path="reloj" element={<PrivateRoute permission="rrhh.reloj"><RrhhRelojPage /></PrivateRoute>} />
              <Route path="personal" element={<Navigate to="/configuracion/personal" replace />} />
              <Route path="configuracion" element={<PrivateRoute permission="rrhh.configuracion"><RrhhConfiguracionPage /></PrivateRoute>} />
              <Route path="index.html" element={<Navigate to="/rrhh/plan-semanal" replace />} />
              <Route path="plan-semanal.html" element={<Navigate to="/rrhh/plan-semanal" replace />} />
              <Route path="aprobaciones.html" element={<Navigate to="/rrhh/jornales" replace />} />
              <Route path="operaciones.html" element={<Navigate to="/rrhh/operaciones" replace />} />
              <Route path="dashboard.html" element={<Navigate to="/rrhh/dashboard" replace />} />
              <Route path="reportes.html" element={<Navigate to="/rrhh/reportes" replace />} />
              <Route path="analisis.html" element={<Navigate to="/rrhh/analisis" replace />} />
              <Route path="mis-marcas.html" element={<Navigate to="/rrhh/mis-marcas" replace />} />
              <Route path="marcas.html" element={<Navigate to="/rrhh/reloj" replace />} />
              <Route path="personal.html" element={<Navigate to="/configuracion/personal" replace />} />
              <Route path="configuracion.html" element={<Navigate to="/rrhh/configuracion" replace />} />
            </Route>

            <Route path="sueldos" element={
              <PrivateRoute anyPermission={RRHH_MANAGEMENT_RESOURCES}><PrivateRoute anyPermission={SUELDOS_ROUTE_PERMISSIONS}><SectionTabs tabs={SUELDOS_TABS} moduleTitle="Personal" moduleSubtitle="Personal, liquidaciones y parámetros" /></PrivateRoute></PrivateRoute>
            }>
              <Route index element={<PersonnelDashboard />} />
              <Route path="empleados" element={<PrivateRoute permission="configuracion.personal"><EmployeesPage /></PrivateRoute>} />
              <Route path="empleados/:employeeId" element={<PrivateRoute permission="configuracion.personal"><EmployeesPage /></PrivateRoute>} />
              <Route path="licencias" element={<PrivateRoute permission="configuracion.personal"><PayrollOrigins leaves /></PrivateRoute>} />
              <Route path="certificaciones" element={<PrivateRoute permission="configuracion.personal"><EmployeeSection title="Certificaciones" kind="certifications" /></PrivateRoute>} />
              <Route path="prestamos" element={<PrivateRoute permission="configuracion.personal"><PayrollOrigins /></PrivateRoute>} />
              <Route path="sanciones" element={<PrivateRoute permission="configuracion.personal"><Sanctions /></PrivateRoute>} /><Route path="sanciones/:id" element={<PrivateRoute permission="configuracion.personal"><Sanctions /></PrivateRoute>} />
              <Route path="liquidaciones" element={<PrivateRoute permission="configuracion.personal"><Liquidations /></PrivateRoute>} />
              <Route path="liquidaciones/:periodId" element={<PrivateRoute permission="configuracion.personal"><PayrollIndividuals /></PrivateRoute>} />
              <Route path="evaluaciones" element={<PrivateRoute permission="configuracion.personal"><Evaluations /></PrivateRoute>} />
              <Route path="parametros-nuevos" element={<PrivateRoute permission="configuracion.personal"><FieldLists /></PrivateRoute>} />
              <Route path="personal" element={<PrivateRoute permission="configuracion.personal"><PersonnelPage /></PrivateRoute>} />
              <Route path="liquidacion" element={<PrivateRoute permission="rrhh.liquidacion"><Navigate to="/sueldos/liquidaciones" replace /></PrivateRoute>} />
              <Route path="tarifas-personal" element={<PrivateRoute permission="rrhh.remuneraciones"><Navigate to="/sueldos/salarial/sueldos" replace /></PrivateRoute>} />
              <Route path="parametros" element={<PrivateRoute permission="rrhh.liquidacion-parametros"><RrhhLiquidacionParametrosPage /></PrivateRoute>} />
              <Route path="salarial" element={<PrivateRoute permission="rrhh.configuracion"><SalarialPage /></PrivateRoute>}>
                <Route index element={<SalaryDashboard />} />
                <Route path="sueldos" element={<div className="card"><h2>Sueldos</h2><p>La configuración de sueldos se definirá en esta sección.</p></div>} />
                <Route path="categorias" element={<SalaryCategories />} />
                <Route path="tarifas-operaciones" element={<RrhhTarifasOperacionesPage />} />
              </Route>
              <Route path="tarifas-operaciones" element={<PrivateRoute permission="rrhh.configuracion"><Navigate to="/sueldos/salarial/tarifas-operaciones" replace /></PrivateRoute>} />
            </Route>

            {/* URLs previas de RRHH: se conservan como compatibilidad de navegación. */}
            <Route path="rrhh/liquidacion" element={<PrivateRoute permission="rrhh.liquidacion"><Navigate to="/sueldos/liquidaciones" replace /></PrivateRoute>} />
            <Route path="rrhh/tarifas-personal" element={<PrivateRoute permission="rrhh.remuneraciones"><Navigate to="/sueldos/tarifas-personal" replace /></PrivateRoute>} />
            <Route path="rrhh/liquidacion-parametros" element={<PrivateRoute permission="rrhh.liquidacion-parametros"><Navigate to="/sueldos/parametros" replace /></PrivateRoute>} />
            <Route path="rrhh/tarifas-operaciones" element={<PrivateRoute permission="rrhh.configuracion"><Navigate to="/sueldos/tarifas-operaciones" replace /></PrivateRoute>} />
            <Route path="rrhh/liquidacion.html" element={<PrivateRoute permission="rrhh.liquidacion"><Navigate to="/sueldos/liquidaciones" replace /></PrivateRoute>} />

            {/* Redirects de rutas viejas */}
            <Route path="quotes" element={<Navigate to="/ventas/cotizaciones" replace />} />
            <Route path="quotes/:id" element={<QuoteRedirect />} />
            <Route path="clients" element={<Navigate to="/ventas/clientes" replace />} />
            <Route path="products" element={<Navigate to="/ventas/productos" replace />} />
            <Route path="lugares" element={<Navigate to="/ventas/lugares" replace />} />
            <Route path="admin" element={<Navigate to="/configuracion/personal" replace />} />
            <Route path="personnel" element={<Navigate to="/configuracion/personal" replace />} />
            <Route path="settings" element={<Navigate to="/configuracion/ia" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  );
}
